module.exports = __webpack_public_path__ + "img/137.dedb5ed3.jpg";